var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.componentToRender,_vm._g(_vm._b({tag:"component"},'component',_setup.boundProps,false),_setup.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }